export default [
    {
        path: "/",
        name: "Home",
        title: "南外人考试系统",
        meta: {
            requireAuth: true
        },
        component: () => import("../views/Home.vue")
    },
    {
        path: "/login",
        name: "Login",
        title: "登陆",
        meta: {
            requireAuth: false
        },
        component: () => import("../views/Login.vue")
    },
    {
        path: "/Permanentlogin",
        name: "PermanentLogin",
        title: "登陆",
        meta: {
            requireAuth: false
        },
        component: () => import("../views/PermanentLogin.vue")
    },
    {
        path: "/exam/:id",
        name: "Exam",
        title: "考试",
        meta: {
            requireAuth: true,
            permanentAuth: false,
        },
        component: () => import("../views/Exam.vue")
    },
    {
        path: "/submit/:id",
        name: "Submit",
        title: "考试记录",
        meta: {
            requireAuth: true,
            permanentAuth: true, // 永久验证
        },
        component: () => import("../views/Submit.vue")
    },
    {
        path: "/preview/:id",
        name: "Preview",
        title: "试卷预览",
        meta: {
            requireAuth: true,
            permanentAuth: true,
        },
        component: () => import("../views/Preview.vue")
    },
]